import { render, staticRenderFns } from "./TaskItemDetailRemove.component.vue?vue&type=template&id=44b6cd1b&scoped=true&"
import script from "./TaskItemDetailRemove.component.vue?vue&type=script&lang=js&"
export * from "./TaskItemDetailRemove.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6cd1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
